import type { Value } from 'modules/core/components/MultiFilters/hooks/utils/defaultEvaluators'
import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'
import type User from 'modules/core/store/models/User'

import { employeeJobTitle } from 'modules/contracts/lib/utils'
import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { employeeJobRole } from 'modules/job_catalog/store/collections/roles'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { employeeTeams } from 'modules/teams/store/employeeTeams'

export default (user: User, value: Value) => {
  switch (value) {
    case 'employee_status':
      return user.employee

    case 'user':
      return user

    case 'employee_name':
      return user.fullName()

    case 'location':
      return user.employee?.attributes.location_id

    case 'team':
      return user.employee
        ? employeeTeams(teams, memberships, user.employee.id).map((team) => team.attributes.id)
        : []

    case 'legal_entity':
      return user.employee && employeeLegalEntityId(user.employee)

    case 'user_type':
      return (!user.employee).toString()

    case 'job_title':
      return user.employee ? employeeJobTitle(contractVersions, user.employee) : ''
    case 'job_role':
      return user.employee ? employeeJobRole(contractVersions, user.employee)?.attributes.name : ''
  }
}
